import axios from "axios";

export default {
    create(data) {
        return axios({
            method: "post",
            data: data,
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/petitioner",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    get(id) {
        return axios({
            method: "get",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/petitioner/" + id,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAll(currentPage = 0, pageSize = 10, filter) {
        return axios({
            method: "get",
            params: filter,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/petitioners?page=" +
                currentPage +
                "&size=" +
                pageSize,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getPdf(id) {
        return axios({
            method: "get",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/petitioner/report/" + id,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    send(id) {
        return axios({
            method: "get",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/petitioner/send/" + id,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getByToken(token) {
        return axios({
            method: "get",
            url: process.env.VUE_APP_BASE_URL_CORE + "public/petitioner/" + token,
            headers: {
                "X-CSRF-TOKEN": "",
            },
        });
    },
    getPdfByToken(token) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE + "public/petitioner/report/" + token,
            headers: {
                "X-CSRF-TOKEN": "",
            },
        });
    },
};
